import React, {Component} from 'react'
import {Button} from 'reactstrap'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation} from 'react-apollo'
import {toast} from "react-toastify";

import AddressInput from '../address/AddressInput'
import addProjectAddressesMutation from '../../../queries/server/mutations/add_project_addresses_manual'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'

export default class ProjectAddressInput extends Component {

  state = {
    modalOpen: false,
    abode_name_no: '',
    building_no: '',
    street: '',
    city: '',
    county: '',
    postcode: '',
    name: '',
  }

  toggle = () => {
    this.setState({modalOpen: !this.state.modalOpen})
  }

  onChange = ({key, value}) => {
    this.setState({[key]: value})
  }

  render() {
    return (
      <div>
        <Button
            size="sm"
            color="success"
            onClick={this.toggle}
        >
            <FontAwesomeIcon color="#fff" icon="plus"/>
            Add Location
        </Button>
        <Mutation mutation={editProjectLocalMutation}>
          {(editProjectLocalMutationFunc) => (
            <Mutation mutation={addProjectAddressesMutation}>
              {(addProjectAddressesMutationFunc, {loading}) => (
                <AddressInput
                  isOpen={this.state.modalOpen}
                  toggle={this.toggle}
                  title="Add Project Location"
                  onChange={this.onChange}
                  loading={loading}
                  onValidSubmit={(address) => {
                    addProjectAddressesMutationFunc({
                      variables: {
                        project_id: this.props.project_id,
                        data: [address],
                      }
                    })
                    .then(({data}) => {
                      editProjectLocalMutationFunc({
                        variables: {data: data.upsertProjectAddressesManual}
                      })
                      this.toggle();
                      toast.success('Project Location Added', {autoClose: 2000})
                    })
                    .catch(e => {
                      toast.error(e.message, {autoClose: false})
                    })
                  }}
                  {...this.state}
                />
              )}
            </Mutation>
          )}
        </Mutation>
      </div>
    )
  }
}

ProjectAddressInput.propTypes = {
  project_id: PropTypes.string.isRequired,
}